import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import sanitizeHTML from "sanitize-html";
import velocity from "velocity-animate";
import { addElasticOut } from "./modules/addExtraEasings";

addElasticOut(velocity, "customEaseElasticOut");

Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;

Vue.prototype.$sanitize = sanitizeHTML;
Vue.filter("toLocaleString", (value) => {
  return value.toLocaleString();
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// memo
// shadow: 0.06667vw
